import { useEffect, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
// import Logo from './../../logo.svg'
import defaultProfile from './../../images/defaultProfile.svg'
import { getContent } from './../../util/api'
import toast, { Toaster } from 'react-hot-toast'
import styles from '../../styles/module/RootLayout.module.scss'

const Header = (props) => {
  const [data, setData] = useState()
  const [content, setContent] = useState()
  const navigate = useNavigate()
  let location = useLocation()

  const handleNavLink = (route) => {
    navigate(route)
    handleOpenNav()
  }

  const handleOpenNav = () => {
    document.querySelector('#modal').classList.toggle('open')
    document.querySelector('.cover').classList.toggle('showCover')
  }

  const getResponse = async () => {
    return await sessionStorage.getItem('Response')
  }

  useEffect(() => {
    getResponse().then((res) => {
      setData(JSON.parse(res))
    })

    document.body.addEventListener('onbeforeunload', () => {
      console.log('*')
    })

    getContent().then((res) => {
      console.log(res)
      setContent(res)
      const root = document.querySelector(':root')
      root.style.setProperty('--home-bg-color', `${res[0].home_bg_color}`)
      root.style.setProperty('--national-anthem-bg-color', `${res[0].national_anthem_bg_color}`)
      root.style.setProperty('--regions-bg-color', `${res[0].regions_bg_color}`)
    })
  }, [])
  return (
    <>
      <Toaster />
      {props.userStatus !== null && props.userStatus === false && (
        <div className={styles.network}>
          <span>شما آفلاین هستید لطفا اینترنت خود را فعال کنید.</span>
        </div>
      )}

      <header className={styles.header}>
        <div onClick={() => handleOpenNav()}>
          <button className={`noSelect`}>
            <small>صفحات</small>
          </button>
          <span className={styles.headerTxt}></span>
        </div>

        <div className={`d-flex align-items-center grid--gap-1`}>
          

          <Link to="/">
            {content && (
              <>
                <figure className={``}>
                  <img alt="لوگو شهرداری اردبیل" src={process.env.REACT_APP_UPLOAD + 'images/' + content[0].logo} />
                </figure>
              </>
            )}

            {/* {
              location.pathname !=='/'   && <span style={{color:'white', position:'absolute',bottom: '-1.5rem', left: '50%',transform:'translateX(-50%)', background:'var(--primary-color)',
              padding:'.2rem 1rem', borderRadius: '99px'}}> بازگشت </span>
            }
           */}
          </Link>
        </div>

        <div>
          <div className={`${styles.headerTxt} d-flex align-items-center justify-content-center`} style={{ height: '20px' }}>
            {content && <>{content[0].slogan}</>}
          </div>
          {data && (
            <div className="d-flex flex-column justify-content-center align-items-center">
              <Link to="/profile">
                <img alt="" src={defaultProfile} />
              </Link>
              <span
                className="animate__animated animate__heartBeat"
                style={{ fontSize: '10px', background: 'red', cursor: 'pointer', position: 'absolute', bottom: '0px', borderRadius: '999px', padding: '0 .5rem', left: '15px' }}
                onClick={() => {
                  localStorage.clear()
                  toast.success(`شما با موفقیت از سیستم خارج شدید`)
                  window.open(`https://ssokeshvar.moi.ir/logout`)
                  window.location.reload()
                }}
              >
                خروج
              </span>
            </div>
          )}
        </div>
      </header>

      <div className="cover" onClick={() => handleOpenNav()} />

      <aside id="modal">
        {content && (
          <>
            <figure className={`d-flex flex-column grid--gap-1`}>
              <img alt="لوگو شهرداری اردبیل" src={process.env.REACT_APP_UPLOAD + 'images/' + content[0].menu_logo} />
              <figcaption>سازمان فناوری اطلاعات و ارتباطات </figcaption>
            </figure>
          </>
        )}

        <ul>
          <li>
            <button onClick={() => handleNavLink('/')}>
              <svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.55 30.05H9.6V18.05H18.4V30.05H26.45V11.35L14 1.95L1.55 11.35V30.05ZM0 31.6V10.6L14 0L28 10.6V31.6H16.85V19.6H11.15V31.6H0Z" fill="black" />
              </svg>
              <span>خانه</span>
            </button>
          </li>
          <li>
            <button
              onClick={() => {
                handleNavLink('/setting')
              }}
            >
              <svg viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.25 36L13.45 30.3C12.7167 30.0667 11.9083 29.7 11.025 29.2C10.1417 28.7 9.40001 28.1667 8.80001 27.6L3.50001 30L0.200012 24.1L4.90001 20.6C4.83335 20.2 4.77501 19.775 4.72501 19.325C4.67501 18.875 4.65001 18.45 4.65001 18.05C4.65001 17.65 4.67501 17.2333 4.72501 16.8C4.77501 16.3667 4.83335 15.9 4.90001 15.4L0.200012 11.9L3.50001 6.05L8.75001 8.4C9.45001 7.83333 10.2167 7.30833 11.05 6.825C11.8833 6.34167 12.6667 5.98333 13.4 5.75L14.25 0H20.95L21.75 5.75C22.5833 6.08333 23.375 6.45833 24.125 6.875C24.875 7.29167 25.6 7.8 26.3 8.4L31.7 6.05L35 11.9L30.15 15.45C30.2833 15.9167 30.3667 16.3583 30.4 16.775C30.4333 17.1917 30.45 17.6 30.45 18C30.45 18.3667 30.425 18.7583 30.375 19.175C30.325 19.5917 30.25 20.05 30.15 20.55L35 24.1L31.65 30L26.3 27.6C25.5667 28.2 24.825 28.7333 24.075 29.2C23.325 29.6667 22.55 30.0167 21.75 30.25L20.95 36H14.25ZM17.5 22.75C18.8333 22.75 19.9583 22.2917 20.875 21.375C21.7917 20.4583 22.25 19.3333 22.25 18C22.25 16.6667 21.7917 15.5417 20.875 14.625C19.9583 13.7083 18.8333 13.25 17.5 13.25C16.1667 13.25 15.0333 13.7083 14.1 14.625C13.1667 15.5417 12.7 16.6667 12.7 18C12.7 19.3333 13.1667 20.4583 14.1 21.375C15.0333 22.2917 16.1667 22.75 17.5 22.75ZM17.5 21.25C16.6 21.25 15.8333 20.9333 15.2 20.3C14.5667 19.6667 14.25 18.9 14.25 18C14.25 17.1 14.5667 16.3333 15.2 15.7C15.8333 15.0667 16.6 14.75 17.5 14.75C18.4 14.75 19.1583 15.0667 19.775 15.7C20.3917 16.3333 20.7 17.1 20.7 18C20.7 18.9 20.3917 19.6667 19.775 20.3C19.1583 20.9333 18.4 21.25 17.5 21.25ZM15.5 34.45H19.65L20.4 28.9C21.4 28.6333 22.3333 28.2583 23.2 27.775C24.0667 27.2917 24.9333 26.6333 25.8 25.8L30.95 28L32.95 24.55L28.4 21.15C28.5333 20.55 28.6333 20 28.7 19.5C28.7667 19 28.8 18.5 28.8 18C28.8 17.4667 28.7667 16.9583 28.7 16.475C28.6333 15.9917 28.5333 15.4667 28.4 14.9L33 11.45L31 8L25.75 10.2C25.1167 9.5 24.2917 8.83333 23.275 8.2C22.2583 7.56667 21.2833 7.2 20.35 7.1L19.7 1.55H15.5L14.9 7.05C13.8 7.25 12.8167 7.60833 11.95 8.125C11.0833 8.64167 10.2167 9.31667 9.35001 10.15L4.20001 8L2.20001 11.45L6.70001 14.8C6.56668 15.3 6.45835 15.8167 6.37501 16.35C6.29168 16.8833 6.25001 17.45 6.25001 18.05C6.25001 18.5833 6.29168 19.1083 6.37501 19.625C6.45835 20.1417 6.56668 20.65 6.70001 21.15L2.20001 24.55L4.20001 28L9.30001 25.85C10.1 26.65 10.95 27.3 11.85 27.8C12.75 28.3 13.75 28.6833 14.85 28.95L15.5 34.45Z"
                  fill="black"
                />
              </svg>
              <span>تنظیمات</span>
            </button>
          </li>
          <li>
            <button
              onClick={() => {
                handleNavLink('/brand-resource')
              }}
            >
              <svg viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M29.55 12.2L23.6 6.30001L26.6 3.35001C27.1333 2.81667 27.775 2.55001 28.525 2.55001C29.275 2.55001 29.9333 2.81667 30.5 3.35001L32.5 5.40001C33.0333 5.93334 33.3 6.58334 33.3 7.35001C33.3 8.11667 33.0333 8.75001 32.5 9.25001L29.55 12.2ZM1.85001 34V28L11.2 18.6L0.450012 7.75001L7.35001 0.850006L18.2 11.7L23.6 6.30001L29.55 12.2L24.2 17.65L35 28.5L28.1 35.35L17.25 24.6L7.80001 34H1.85001ZM12.35 17.5L17.1 12.75L12.7 8.35001L10.35 10.75L9.25001 9.65001L11.6 7.25001L7.35001 3.00001L2.60001 7.75001L12.35 17.5ZM28.05 33.25L32.8 28.45L28.55 24.2L26.15 26.55L25.05 25.45L27.45 23.1L23.05 18.7L18.3 23.5L28.05 33.25ZM3.35001 32.45H7.15001L27.3 12.25L23.55 8.50001L3.35001 28.65V32.45Z"
                  fill="black"
                />
              </svg>
              <span>منابع برند</span>
            </button>
          </li>
          <li>
            <button
              onClick={() => {
                handleNavLink('/download')
              }}
            >
              <svg viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 27.35H27V25.8H9V27.35ZM17.95 20.8L24.5 14.3L23.4 13.2L18.7 17.9V7.35001H17.15V17.9L12.5 13.2L11.4 14.3L17.95 20.8ZM18 36.35C15.5333 36.35 13.2083 35.875 11.025 34.925C8.84167 33.975 6.93333 32.6833 5.3 31.05C3.66667 29.4167 2.375 27.5167 1.425 25.35C0.475 23.1833 0 20.85 0 18.35C0 15.85 0.475 13.5083 1.425 11.325C2.375 9.14167 3.66667 7.24167 5.3 5.62501C6.93333 4.00834 8.83333 2.72501 11 1.77501C13.1667 0.825006 15.5 0.350006 18 0.350006C20.5 0.350006 22.8417 0.825006 25.025 1.77501C27.2083 2.72501 29.1083 4.00834 30.725 5.62501C32.3417 7.24167 33.625 9.14167 34.575 11.325C35.525 13.5083 36 15.85 36 18.35C36 20.8167 35.525 23.1417 34.575 25.325C33.625 27.5083 32.3417 29.4167 30.725 31.05C29.1083 32.6833 27.2083 33.975 25.025 34.925C22.8417 35.875 20.5 36.35 18 36.35ZM18 34.8C22.5667 34.8 26.45 33.2 29.65 30C32.85 26.8 34.45 22.9167 34.45 18.35C34.45 13.7833 32.85 9.90001 29.65 6.70001C26.45 3.50001 22.5667 1.90001 18 1.90001C13.4333 1.90001 9.55 3.50001 6.35 6.70001C3.15 9.90001 1.55 13.7833 1.55 18.35C1.55 22.9167 3.15 26.8 6.35 30C9.55 33.2 13.4333 34.8 18 34.8Z"
                  fill="black"
                />
              </svg>
              <span> دانلود اپلیکشن</span>
            </button>
          </li>
          <li>
            <button
              onClick={() => {
                handleNavLink('/legal/privacy-policy')
              }}
            >
              <svg viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M24.25 28.1C25.0833 28.1 25.8 27.7917 26.4 27.175C27 26.5583 27.3 25.8333 27.3 25C27.3 24.1667 27 23.45 26.4 22.85C25.8 22.25 25.0833 21.95 24.25 21.95C23.4167 21.95 22.6917 22.2417 22.075 22.825C21.4583 23.4083 21.15 24.1333 21.15 25C21.15 25.8333 21.4583 26.5583 22.075 27.175C22.6917 27.7917 23.4167 28.1 24.25 28.1ZM24.2 34.2C25.3 34.2 26.2917 33.9667 27.175 33.5C28.0583 33.0333 28.8 32.3833 29.4 31.55C28.5667 31.0833 27.725 30.7333 26.875 30.5C26.025 30.2667 25.15 30.15 24.25 30.15C23.3167 30.15 22.4167 30.2667 21.55 30.5C20.6833 30.7333 19.8667 31.0833 19.1 31.55C19.6667 32.3833 20.3833 33.0333 21.25 33.5C22.1167 33.9667 23.1 34.2 24.2 34.2V34.2ZM14 35.75C10 34.5833 6.66667 32.175 4 28.525C1.33333 24.875 0 20.6667 0 15.9V5.2L14 0L28 5.2V17.55C27.7667 17.45 27.5083 17.3583 27.225 17.275C26.9417 17.1917 26.6833 17.1167 26.45 17.05V6.25L14 1.7L1.55 6.25V15.9C1.55 18.3333 1.93333 20.5833 2.7 22.65C3.46667 24.7167 4.475 26.5583 5.725 28.175C6.975 29.7917 8.38333 31.1417 9.95 32.225C11.5167 33.3083 13.1167 34.05 14.75 34.45H14.9C15 34.5167 15.1167 34.6333 15.25 34.8C15.3833 34.9667 15.5 35.1 15.6 35.2C15.3333 35.3333 15.0583 35.4417 14.775 35.525C14.4917 35.6083 14.2333 35.6833 14 35.75V35.75ZM24.3 35.85C22.1667 35.85 20.35 35.1 18.85 33.6C17.35 32.1 16.6 30.2833 16.6 28.15C16.6 25.9833 17.35 24.15 18.85 22.65C20.35 21.15 22.1667 20.4 24.3 20.4C26.4333 20.4 28.25 21.15 29.75 22.65C31.25 24.15 32 25.9833 32 28.15C32 30.2833 31.25 32.1 29.75 33.6C28.25 35.1 26.4333 35.85 24.3 35.85Z"
                  fill="black"
                />
              </svg>
              <span>حریم خصوصی</span>
            </button>
          </li>
          <li>
            <button
              onClick={() => {
                handleNavLink('/legal/how-to-use')
              }}
            >
              <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 36C15.5 36 13.1583 35.525 10.975 34.575C8.79167 33.625 6.89167 32.3417 5.275 30.725C3.65833 29.1083 2.375 27.2083 1.425 25.025C0.475 22.8417 0 20.5 0 18C0 15.5 0.475 13.1583 1.425 10.975C2.375 8.79167 3.65833 6.89167 5.275 5.275C6.89167 3.65833 8.79167 2.375 10.975 1.425C13.1583 0.475 15.5 0 18 0C20.5 0 22.8417 0.475 25.025 1.425C27.2083 2.375 29.1083 3.65833 30.725 5.275C32.3417 6.89167 33.625 8.79167 34.575 10.975C35.525 13.1583 36 15.5 36 18C36 20.5 35.525 22.8417 34.575 25.025C33.625 27.2083 32.3417 29.1083 30.725 30.725C29.1083 32.3417 27.2083 33.625 25.025 34.575C22.8417 35.525 20.5 36 18 36ZM12.1 33.4L15.9 24.6C14.8667 24.2333 13.9583 23.675 13.175 22.925C12.3917 22.175 11.8167 21.2667 11.45 20.2L2.5 23.8C3.43333 26.0667 4.725 28.025 6.375 29.675C8.025 31.325 9.93333 32.5667 12.1 33.4ZM11.45 15.85C11.75 14.75 12.2917 13.8333 13.075 13.1C13.8583 12.3667 14.7667 11.8167 15.8 11.45L12.2 2.5C9.86667 3.43333 7.86667 4.73333 6.2 6.4C4.53333 8.06667 3.3 10 2.5 12.2L11.45 15.85ZM18 23.4C19.5 23.4 20.775 22.875 21.825 21.825C22.875 20.775 23.4 19.5 23.4 18C23.4 16.5 22.875 15.225 21.825 14.175C20.775 13.125 19.5 12.6 18 12.6C16.5 12.6 15.225 13.125 14.175 14.175C13.125 15.225 12.6 16.5 12.6 18C12.6 19.5 13.125 20.775 14.175 21.825C15.225 22.875 16.5 23.4 18 23.4ZM23.95 33.4C26.1167 32.5333 28.0167 31.2833 29.65 29.65C31.2833 28.0167 32.5333 26.1 33.4 23.9L24.6 20.1C24.2667 21.2 23.7083 22.125 22.925 22.875C22.1417 23.625 21.2333 24.1833 20.2 24.55L23.95 33.4ZM24.55 15.75L33.4 12.05C32.5333 9.88333 31.2833 7.98333 29.65 6.35C28.0167 4.71667 26.1167 3.46667 23.95 2.6L20.25 11.45C21.2167 11.85 22.075 12.4083 22.825 13.125C23.575 13.8417 24.15 14.7167 24.55 15.75Z"
                  fill="black"
                />
              </svg>
              <span>شرایط استفاده</span>
            </button>
          </li>
          <li>
            <button
              onClick={() => {
                handleNavLink('/about')
              }}
            >
              <svg viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.3 27.35H18.85V16.35H17.3V27.35ZM18 13.65C18.3 13.65 18.55 13.55 18.75 13.35C18.95 13.15 19.05 12.9 19.05 12.6C19.05 12.2667 18.95 12 18.75 11.8C18.55 11.6 18.3 11.5 18 11.5C17.6667 11.5 17.4083 11.6 17.225 11.8C17.0417 12 16.95 12.2667 16.95 12.6C16.95 12.9 17.05 13.15 17.25 13.35C17.45 13.55 17.7 13.65 18 13.65V13.65ZM18 36.35C15.5 36.35 13.1667 35.875 11 34.925C8.83333 33.975 6.93333 32.6833 5.3 31.05C3.66667 29.4167 2.375 27.5167 1.425 25.35C0.475 23.1833 0 20.85 0 18.35C0 15.85 0.475 13.5083 1.425 11.325C2.375 9.14167 3.66667 7.24167 5.3 5.62501C6.93333 4.00834 8.83333 2.72501 11 1.77501C13.1667 0.825006 15.5 0.350006 18 0.350006C20.5 0.350006 22.8417 0.825006 25.025 1.77501C27.2083 2.72501 29.1083 4.00834 30.725 5.62501C32.3417 7.24167 33.625 9.14167 34.575 11.325C35.525 13.5083 36 15.85 36 18.35C36 20.85 35.525 23.1833 34.575 25.35C33.625 27.5167 32.3417 29.4167 30.725 31.05C29.1083 32.6833 27.2083 33.975 25.025 34.925C22.8417 35.875 20.5 36.35 18 36.35ZM18.05 34.8C22.5833 34.8 26.45 33.2 29.65 30C32.85 26.8 34.45 22.9 34.45 18.3C34.45 13.7667 32.8583 9.90001 29.675 6.70001C26.4917 3.50001 22.6 1.90001 18 1.90001C13.4333 1.90001 9.55 3.49167 6.35 6.67501C3.15 9.85834 1.55 13.75 1.55 18.35C1.55 22.9167 3.15 26.8 6.35 30C9.55 33.2 13.45 34.8 18.05 34.8V34.8Z"
                  fill="black"
                />
              </svg>
              <span>درباره نرم افزار</span>
            </button>
          </li>

          <li>
            <button
              onClick={() => {
                handleNavLink('/contact')
              }}
            >
              <svg viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18 36.35C15.4667 36.35 13.1083 35.8833 10.925 34.95C8.74167 34.0167 6.84167 32.7417 5.225 31.125C3.60833 29.5083 2.33333 27.6083 1.4 25.425C0.466667 23.2417 0 20.8833 0 18.35C0 15.8167 0.466667 13.4583 1.4 11.275C2.33333 9.09167 3.60833 7.19167 5.225 5.57501C6.84167 3.95834 8.74167 2.68334 10.925 1.75001C13.1083 0.816673 15.4667 0.350006 18 0.350006C20.5333 0.350006 22.8917 0.816673 25.075 1.75001C27.2583 2.68334 29.1583 3.95834 30.775 5.57501C32.3917 7.19167 33.6667 9.09167 34.6 11.275C35.5333 13.4583 36 15.8167 36 18.35V20.2C36 21.8667 35.4333 23.2583 34.3 24.375C33.1667 25.4917 31.7667 26.05 30.1 26.05C28.7667 26.05 27.6333 25.7083 26.7 25.025C25.7667 24.3417 25.1 23.4 24.7 22.2C23.9667 23.3667 23.0833 24.3 22.05 25C21.0167 25.7 19.6667 26.05 18 26.05C15.8667 26.05 14.05 25.3 12.55 23.8C11.05 22.3 10.3 20.4833 10.3 18.35C10.3 16.1833 11.05 14.3583 12.55 12.875C14.05 11.3917 15.8667 10.65 18 10.65C20.1333 10.65 21.95 11.3917 23.45 12.875C24.95 14.3583 25.7 16.1833 25.7 18.35V20.2C25.7 21.3667 26.125 22.375 26.975 23.225C27.825 24.075 28.8667 24.5 30.1 24.5C31.3 24.5 32.325 24.075 33.175 23.225C34.025 22.375 34.45 21.3667 34.45 20.2V18.35C34.45 13.8167 32.8417 9.94167 29.625 6.72501C26.4083 3.50834 22.5333 1.90001 18 1.90001C13.4667 1.90001 9.59167 3.50834 6.375 6.72501C3.15833 9.94167 1.55 13.8167 1.55 18.35C1.55 22.8833 3.15833 26.7583 6.375 29.975C9.59167 33.1917 13.4667 34.8 18 34.8H28.3V36.35H18ZM18 24.5C19.7 24.5 21.15 23.9 22.35 22.7C23.55 21.5 24.15 20.05 24.15 18.35C24.15 16.6167 23.55 15.1583 22.35 13.975C21.15 12.7917 19.7 12.2 18 12.2C16.3 12.2 14.85 12.7917 13.65 13.975C12.45 15.1583 11.85 16.6167 11.85 18.35C11.85 20.05 12.45 21.5 13.65 22.7C14.85 23.9 16.3 24.5 18 24.5V24.5Z"
                  fill="black"
                />
              </svg>
              <span>ارتباط با ما</span>
            </button>
          </li>

          <li>
            <button
              onClick={() => {
                handleNavLink('/guide')
              }}
            >
              <svg viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.2 28.65C18.5667 28.65 18.875 28.5167 19.125 28.25C19.375 27.9833 19.5 27.6833 19.5 27.35C19.5 27.0167 19.375 26.7167 19.125 26.45C18.875 26.1833 18.5667 26.05 18.2 26.05C17.8333 26.05 17.525 26.1833 17.275 26.45C17.025 26.7167 16.9 27.0167 16.9 27.35C16.9 27.6833 17.025 27.9833 17.275 28.25C17.525 28.5167 17.8333 28.65 18.2 28.65ZM17.2 22.2H18.8C18.8 21.4333 18.9417 20.7583 19.225 20.175C19.5083 19.5917 20.0667 18.9167 20.9 18.15C21.8667 17.25 22.55 16.4417 22.95 15.725C23.35 15.0083 23.55 14.2 23.55 13.3C23.55 11.7667 23.05 10.5167 22.05 9.55001C21.05 8.58334 19.7833 8.10001 18.25 8.10001C16.9167 8.10001 15.7417 8.45834 14.725 9.17501C13.7083 9.89167 12.9333 10.75 12.4 11.75L13.95 12.4C14.35 11.5333 14.8833 10.8583 15.55 10.375C16.2167 9.89167 17.0667 9.65001 18.1 9.65001C19.4333 9.65001 20.4333 10.0083 21.1 10.725C21.7667 11.4417 22.1 12.3 22.1 13.3C22.1 14 21.9083 14.6417 21.525 15.225C21.1417 15.8083 20.6 16.4167 19.9 17.05C18.9667 17.9167 18.2833 18.7667 17.85 19.6C17.4167 20.4333 17.2 21.3 17.2 22.2V22.2ZM18 36.35C15.5333 36.35 13.2083 35.875 11.025 34.925C8.84167 33.975 6.93333 32.6833 5.3 31.05C3.66667 29.4167 2.375 27.5167 1.425 25.35C0.475 23.1833 0 20.85 0 18.35C0 15.85 0.475 13.5083 1.425 11.325C2.375 9.14167 3.66667 7.24167 5.3 5.62501C6.93333 4.00834 8.83333 2.72501 11 1.77501C13.1667 0.825006 15.5 0.350006 18 0.350006C20.5 0.350006 22.8417 0.825006 25.025 1.77501C27.2083 2.72501 29.1083 4.00834 30.725 5.62501C32.3417 7.24167 33.625 9.14167 34.575 11.325C35.525 13.5083 36 15.85 36 18.35C36 20.8167 35.525 23.1417 34.575 25.325C33.625 27.5083 32.3417 29.4167 30.725 31.05C29.1083 32.6833 27.2083 33.975 25.025 34.925C22.8417 35.875 20.5 36.35 18 36.35ZM18 34.8C22.5667 34.8 26.45 33.2 29.65 30C32.85 26.8 34.45 22.9167 34.45 18.35C34.45 13.7833 32.85 9.90001 29.65 6.70001C26.45 3.50001 22.5667 1.90001 18 1.90001C13.4333 1.90001 9.55 3.50001 6.35 6.70001C3.15 9.90001 1.55 13.7833 1.55 18.35C1.55 22.9167 3.15 26.8 6.35 30C9.55 33.2 13.4333 34.8 18 34.8Z"
                  fill="black"
                />
              </svg>
              <span>راهنمای استفاده</span>
            </button>
          </li>
        </ul>
      </aside>
    </>
  )
}

Header.defaultProps = {
  userStatus: false,
}

export default Header
